module.exports = __webpack_public_path__ + "static/media/view book.25aec178.svg";